<template>
    <Toast :baseZIndex="9999" />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <DataTable :value="userslist" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" data-key="mav1" :rowHover="true"
                    v-model:expandedRows="expandedRows"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Users </h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add User" icon="pi pi-plus" class=" p-mr-2"
                                @click="addSuperAdminUsersDialogOpen" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data Please wait... </template>
                    <Column header="User Name" headerStyle="width: 40%" class="p-text-capitalize">
                        <template #body="{ data }">
                            <!-- <div class="p-text-capitalize">{{ mav8 || 'N/A' }}</div> -->
                            <div class="p-d-flex p-ai-center">
                                <div class="p-mr-3">
                                    <span v-if="data.mav16 != null && data.mav16 != ''">
                                        <img :src="getStoragePath + clientBucketName + '/SuperAdmin/Logo/' + data.mav17"
                                            width="50" height="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                    <span v-else>
                                        <img src="/assets/layout/images/widgets/asset-profile-11.png" width="50"
                                            height="50" style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                </div>
                                <div>
                                    <div class="p-text-capitalize overflow-span">{{ data.mav8 ? data.mav8
                                        : 'N/A' }}</div>
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column header="Contact Details" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <div>
                                <div>{{ data.mav9 ? this.allow_to_display_mobile_number == 0 ? '+91' +
                                    maskedNumber(data.mav9) : '+91' + data.mav9 : 'N/A' }}</div>
                                <div class="p-mt-1"><small class="muted-text overflow-span">
                                        {{ data.mav10 ? this.allow_to_display_email_id == 0 ? maskEmail(data.mav10) :
                                        data.mav10 : 'N/A' }}</small>
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data: { mav15 } }">
                            <span v-if="mav15 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="mav15 == 2" :class="'user-badge status-temp-suspend'">Temporarily
                                Suspended</span>
                            <span v-if="mav15 == 3" :class="'user-badge status-per-suspend'">Permanently
                                Suspended</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success"
                                @click="editSuperAdminUserDialogOpen(data)" />
                            <Button icon="pi pi-cog" class="p-button-rounded p-ml-1"
                                @click="showCriticalPermissionsOfUser(data)" v-tooltip.right="'Critical Permissions'" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- add super admin user dialog start here -->
    <Dialog v-model:visible="addUserStatus" :style="{ width: '1000px' }" header="Add User" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-3">
                    <label for="title">
                        Title
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="title" v-model="title" :options="titleList" optionLabel="label" placeholder="Select"
                        appendTo="body">
                    </Dropdown>
                    <small class="p-invalid p-error" v-if="v$.title.$error">{{ v$.title.required.$message }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="userfirstname">
                        First Name
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="userfirstname" class="p-text-capitalize" v-model.trim="userfirstname" required="true"
                        maxlength="30" autofocus placeholder="enter first name"
                        :class="{ 'p-invalid': submitted && !userfirstname }" />
                    <small class="p-invalid p-error" v-if="v$.userfirstname.$error">{{
                        v$.userfirstname.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="usermiddlename">
                        Middle Name
                    </label>
                    <InputText id="usermiddlename" placeholder="Enter middle name" class="p-text-capitalize"
                        v-model.trim="usermiddlename" maxlength="30" autofocus />
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="userlastname">
                        Last Name
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="userlastname" class="p-text-capitalize" v-model.trim="userlastname" required="true"
                        maxlength="30" autofocus placeholder="Enter last name"
                        :class="{ 'p-invalid': submitted && !userlastname }" />
                    <small class="p-invalid p-error" v-if="v$.userlastname.$error">{{
                        v$.userlastname.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="usermobile">
                        Mobile No.
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            +91
                        </span>
                        <InputText id="usermobile" v-model="usermobile" autocomplete="off" maxlength="10"
                            @keypress="onlyNumber" autofocus placeholder="Enter mobile no."
                            :class="{ 'p-invalid': submitted && !usermobile }" />
                    </div>
                    <small class="p-invalid p-error" v-if="v$.usermobile.$error">{{
                        v$.usermobile.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="user-email">
                        Email
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="user-email" v-model.trim="userEmail" required="true" autocomplete="usremail"
                        maxlength="70" autofocus placeholder="Enter email id"
                        :class="{ 'p-invalid': submitted && !userEmail }" />
                    <small class="p-invalid p-error" v-if="v$.userEmail.$error">{{
                        v$.userEmail.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Team Lead</label>
                    <Dropdown v-model="teamLeadFK" :options="teamLeadUsersList" optionLabel="mav8" optionValue="mav1"
                        placeholder="Select Team Lead" appendTo="body" :showClear="true" />
                </div>
                <!-- <div class="p-field p-col-12 p-md-6">
                    <label>Status <span class="p-invalid p-error"> *</span></label>
                    <div class="p-field-radiobutton">
                        <RadioButton id="active_type" name="option" :value="1" v-model="statustype" />
                        <label for="active_type" class="p-mr-2">Active</label>
                        <RadioButton id="temp_suspend_type" name="option" :value="2" v-model="statustype" />
                        <label for="temp_suspend_type" class="p-mr-2">Temporarily Suspended</label>
                        <RadioButton id="per_suspend_type" name="option" :value="3" v-model="statustype" />
                        <label for="per_suspend_type" class="p-mr-2">Permanently Suspended</label>
                    </div>
                    <small class="p-invalid p-error" v-if="v$.statustype.$error">{{
                        v$.statustype.$errors[0].$message
                        }}</small>
                </div> -->
                <div class="p-field p-col-12 p-md-6">
                    <label>Upload Profile</label>
                    <FileUpload mode="basic" ref="profileImage" accept="image/*" :maxFileSize="1000000"
                        chooseLabel="Upload Profile" auto @select="onSelectProfile">
                    </FileUpload>
                    <img v-if="profileUrl" class="p-pt-2" role="presentation" :alt="profileUrl.name"
                        :src="profileUrl.url" width="120" height="120" />
                    <!-- <small class="p-invalid p-error" v-if="v$.profileImage.$error">{{
                        v$.profileImage.$errors[0].$message
                    }}</small> -->
                    <small class="p-invalid p-error" v-if="profileImageError">{{ profileImageError }}</small>
                </div>
             
                <div class="p-field p-col-12 p-md-6">
                    <label>Allow To send Support Ticket Notification <span class="p-invalid p-error">*</span></label>
                    <div class="p-field-radiobutton">
                        <RadioButton id="notallow" name="role-option" :value="0" v-model="citizenStatus" />
                        <label for="notallow" class="p-mr-2">No</label>
                        <RadioButton id="allow" name="role-option" :value="1" v-model="citizenStatus" />
                        <label for="allow" class="p-mr-2">Yes</label>
                    </div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Permission Type<span class="p-invalid p-error">*</span></label>
                    <div class="p-field-radiobutton">
                        <RadioButton id="rolewise" name="role-option" :value="1" v-model="roletype" />
                        <label for="rolewise" class="p-mr-2">Set Wise</label>
                        <RadioButton id="manualrole" name="role-option" :value="2" v-model="roletype" />
                        <label for="manualrole" class="p-mr-2">Manual Permissions</label>
                        <small class="p-invalid p-error" v-if="v$.roletype.$error">
                            {{ v$.roletype.$errors[0].$message }}
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-12 p-md-6" v-if="roletype == 1">
                    <div class="custom-form-group">
                        <label class="form-label">Permission Set<span class="p-invalid p-error">*</span></label>
                        <Dropdown id="userrole" v-model="userrole" :options="userrole_list" optionLabel="label"
                            required="true" placeholder="Select Role" emptyMessage="No Records" appendTo="body" />
                        <small class="p-invalid p-error" v-if="v$.userrole.$error && roletype == 1">
                            {{ v$.userrole.$errors[0].$message }}
                        </small>
                    </div>
                </div>

                <div class="p-field p-col-12 p-md-12" v-if="roletype == 2">
                    <label style="margin-bottom: 2%;"> Select Menu <span class="p-invalid p-error"> *
                        </span></label>
                    <div class="p-grid" style="margin-bottom: 1%;">
                        <div v-if="!isExpanded" class="p-col-3 p-md-3">
                            <Button label="Expand All" @click="toggleExpand" icon="pi pi-plus" />
                        </div>
                        <div v-if="isExpanded" class="p-col-3 p-md-3">
                            <Button label="Collapse All" @click="toggleExpand" icon="pi pi-minus" />
                        </div>
                        <div class="p-col-3 p-md-3">
                            <Button :label="isAllSelected ? 'Unselect All' : 'Select All'" @click="toggleSelectAll"
                                :icon="isAllSelected ? 'pi pi-times' : 'pi pi-check'" />
                        </div>
                    </div>
                    <Tree :value="nodes" selectionMode="checkbox" v-model:selectionKeys="selectedTreeValue"
                        :expandedKeys="expandedKeys" class="custom-users-role">
                    </Tree>
                    <small class="p-invalid p-error" v-if="v$.selectedTreeValue.$error">
                        {{ v$.selectedTreeValue.$errors[0].$message }}
                    </small>
                </div>
            </div>
        </div>
        <template #footer>
            <div>
                <Button v-if="!showLoader" label="Submit" icon="pi pi-check" class="p-button-text p-ml-auto"
                    @click="addNewSuperAdminUser" style="width: 90px"></Button>
                <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                    style="width: 90px"></Button>
            </div>
        </template>
    </Dialog>
    <!-- add super admin user dialog end here -->
    <!-- edit super admin user dialog start here -->
    <Dialog v-model:visible="editUserStatus" :style="{ width: '1000px' }" header="Edit User" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-3">
                    <label for="title">
                        Title
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="title" v-model="title" :options="titleList" optionLabel="label" placeholder="Select"
                        appendTo="body">
                    </Dropdown>
                    <small class="p-invalid p-error" v-if="v$.title.$error">{{ v$.title.required.$message }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="userfirstname">
                        First Name
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="userfirstname" class="p-text-capitalize" v-model.trim="userfirstname" required="true"
                        maxlength="30" autofocus :class="{ 'p-invalid': submitted && !userfirstname }" />
                    <small class="p-invalid p-error" v-if="v$.userfirstname.$error">{{
                        v$.userfirstname.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="usermiddlename">
                        Middle Name</label>
                    <InputText id="usermiddlename" class="p-text-capitalize" v-model.trim="usermiddlename"
                        maxlength="30" autofocus />
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="userlastname">
                        Last Name
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="userlastname" class="p-text-capitalize" v-model.trim="userlastname" required="true"
                        maxlength="30" autofocus :class="{ 'p-invalid': submitted && !userlastname }" />
                    <small class="p-invalid p-error" v-if="v$.userlastname.$error">{{
                        v$.userlastname.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="usermobile">
                        Mobile No.
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            +91
                        </span>
                        <InputText id="usermobile" v-model="usermobile" autocomplete="off" maxlength="10"
                            @keypress="onlyNumber" autofocus :class="{ 'p-invalid': submitted && !usermobile }" />
                    </div>
                    <small class="p-invalid p-error" v-if="v$.usermobile.$error">{{
                        v$.usermobile.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="user-email">
                        Email
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="user-email" v-model.trim="userEmail" required="true" autocomplete="user-email"
                        maxlength="70" autofocus :class="{ 'p-invalid': submitted && !userEmail }" />
                    <small class="p-invalid p-error" v-if="v$.userEmail.$error">{{
                        v$.userEmail.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-3">
                    <label for="user-password">
                        Password
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <!-- <InputText id="user-password" v-model.trim="userPassword" toggleMask required="true" autocomplete="user-password"
                        maxlength="12" autofocus :class="{ 'p-invalid': submitted && !userPassword }" /> -->
                    <Password id="password" v-model="userPassword" toggleMask autofocus maxLength="20"
                        :class="{ 'p-invalid': submitted && !userPassword }" />
                    <small class="p-invalid p-error" v-if="v$.userPassword.$error">{{
                        v$.userPassword.$errors[0].$message
                    }}</small>
                </div>
                 <div class="p-field p-col-12 p-md-3">
                    <label>Team Lead <span class="p-invalid p-error">*</span></label>
                    <Dropdown v-model="teamLeadFK" :options="teamLeadUsersList" optionLabel="mav8" optionValue="mav1"
                        placeholder="Select Team Lead" appendTo="body" :class="{ 'p-invalid': submitted && !teamLeadFK }" />
                    <small class="p-invalid p-error" v-if="submitted && !teamLeadFK">Please select team lead</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Status <span class="p-invalid p-error"> *</span></label>
                    <div class="p-field-radiobutton">
                        <RadioButton id="active_type" name="option" v-bind:value="1" v-model="statustype"
                            :checked="statustype == 1" />
                        <label for="active_type" class="p-mr-2">Active</label>
                        <RadioButton id="temp_suspend_type" name="option" v-bind:value="2" v-model="statustype"
                            :checked="statustype == 2" />
                        <label for="temp_suspend_type" class="p-mr-2">Temporarily Suspended</label>
                        <RadioButton id="per_suspend_type" name="option" v-bind:value="3" v-model="statustype"
                            :checked="statustype == 3" />
                        <label for="per_suspend_type" class="p-mr-2">Permanently Suspended</label>
                    </div>
                    <small class="p-invalid p-error" v-if="v$.statustype.$error">{{
                        v$.statustype.$errors[0].$message
                    }}</small>
                </div>
               
                <div class="p-field p-col-12 p-md-6">
                    <label>Upload Profile </label>
                    <FileUpload mode="basic" ref="profileImage" accept="image/*" :maxFileSize="1000000"
                        chooseLabel="Upload Profile" auto @select="onSelectProfile">
                    </FileUpload>
                    <span v-if="profileUrl == null">
                        <img v-if="userprofilefile" class="p-pt-2" role="presentation" alt="userprofile87878"
                            :src="userprofilefile" width="120" height="120" />
                    </span>
                    <img v-if="profileUrl" class="p-pt-2" role="presentation" :alt="profileUrl.name"
                        :src="profileUrl.url" width="120" height="120" />
                    <!-- <small class="p-invalid p-error" v-if="v$.profileImage.$error">{{
                        v$.profileImage.$errors[0].$message
                    }}</small> -->
                    <small class="p-invalid p-error" v-if="profileImageError">{{ profileImageError }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Allow To send Support Ticket Notification<span class="p-invalid p-error">*</span></label>
                    <div class="p-field-radiobutton">
                        <RadioButton id="notallow" name="role-option" :value="0" v-model="citizenStatus" />
                        <label for="notallow" class="p-mr-2">No</label>
                        <RadioButton id="allow" name="role-option" :value="1" v-model="citizenStatus" />
                        <label for="allow" class="p-mr-2">Yes</label>
                    </div>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Permission Type<span class="p-invalid p-error">*</span></label>
                    <div class="p-field-radiobutton">
                        <RadioButton id="rolewise" name="role-option" :value="1" v-model="roletype" />
                        <label for="rolewise" class="p-mr-2">Set Wise</label>
                        <RadioButton id="manualrole" name="role-option" :value="2" v-model="roletype" />
                        <label for="manualrole" class="p-mr-2">Manual Permissions</label>
                        <small class="p-invalid p-error" v-if="v$.roletype.$error">
                            {{ v$.roletype.$errors[0].$message }}
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-12 p-md-6" v-if="roletype == 1">
                    <div class="custom-form-group">
                        <label class="form-label">Permission Set<span class="p-invalid p-error">*</span></label>
                        <Dropdown id="userrole" v-model="userrole" :options="userrole_list" optionLabel="label"
                            required="true" placeholder="Select Role" emptyMessage="No Records" appendTo="body" />
                        <small class="p-invalid p-error" v-if="v$.userrole.$error && roletype == 1">
                            {{ v$.userrole.$errors[0].$message }}
                        </small>
                    </div>
                </div>

                <div class="p-field p-col-12 p-md-12" v-if="roletype == 2">
                    <label style="margin-bottom: 2%;"> Select Menu <span class="p-invalid p-error"> *
                        </span></label>
                    <div class="p-grid" style="margin-bottom: 1%;">
                        <div v-if="!isExpanded" class="p-col-3 p-md-3">
                            <Button label="Expand All" @click="toggleExpand" icon="pi pi-plus" />
                        </div>
                        <div v-if="isExpanded" class="p-col-3 p-md-3">
                            <Button label="Collapse All" @click="toggleExpand" icon="pi pi-minus" />
                        </div>
                        <div class="p-col-3 p-md-3">
                            <Button :label="isAllSelected ? 'Unselect All' : 'Select All'" @click="toggleSelectAll"
                                :icon="isAllSelected ? 'pi pi-times' : 'pi pi-check'" />
                        </div>
                    </div>
                    <Tree :value="nodes" selectionMode="checkbox" v-model:selectionKeys="selectedTreeValue"
                        :expandedKeys="expandedKeys" class="custom-users-role">
                    </Tree>
                    <small class="p-invalid p-error" v-if="v$.selectedTreeValue.$error">
                        {{ v$.selectedTreeValue.$errors[0].$message }}
                    </small>
                </div>
            </div>
        </div>
        <template #footer>
            <div>
                <Button v-if="!showLoader" label="Submit" icon="pi pi-check" class="p-button-text p-ml-auto"
                    @click="updateSuperAdminUser" style="width: 90px"></Button>
                <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                    style="width: 90px"></Button>
            </div>
        </template>
    </Dialog>
    <!-- edit super admin user dialog end here -->
    <!-- add super admin user dialog start here -->
    <Dialog v-model:visible="userCriticalPermissionsStatus" :style="{ width: '1000px' }" header="Critical Permissions"
        :modal="true" class="p-fluid">
        <DataTable :value="criticalPermissionsList" :lazy="true" :paginator="false" :loading="loading"
            class="p-datatable-users" data-key="value" :rowHover="true">
            <template #empty> No data found. </template>
            <template #loading> Loading data. Please wait... </template>
            <Column header="Sr." headerStyle="width: 5%">
                <template #body="{ index }">
                    {{ ++index }}
                </template>
            </Column>
            <Column header="Permissions" headerStyle="width: 50%">
                <template #body="{ data }">
                    <div>{{ data.label }}</div>
                </template>
            </Column>
            <Column header="Permission Status" headerStyle="width: 20%">
                <template #body="{ data }">
                    <InputSwitch v-model="data.status" @change="serviceStatusChanges(data)" />
                </template>
            </Column>
        </DataTable>
    </Dialog>
    <!-- add super admin user dialog end here -->
</template>
<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import CommonMixins from '../../mixins/common-mixins';
import { required, alpha, helpers, minLength, maxLength, numeric, email, requiredIf } from '@vuelidate/validators';
export default {
    mixins: [CommonMixins],
    data() {
        return {
            v$: useValidate(),
            userslist: [],
            page_no: 0,
            totalRecords: 0,
            loading: false,
            addUserStatus: false,
            editUserStatus: false,
            userfullname: '',
            usershortname: '',
            title: '',
            titleList: [],
            userfirstname: '',
            usermiddlename: '',
            userlastname: '',
            usermobile: '',
            userEmail: '',
            statustype: '',
            showLoader: false,
            submitted: false,
            profileUrl: null,
            profileImage: null,
            profileImageError: '',
            userId: '',
            userprofilefile: null,
            userPassword: '',
            isExpanded: false,

            roletype: '',
            userrole: '',
            expandedKeys: [],
            userrole_list: [],
            nodes: [],
            expandedRows: [],
            selectedTreeValue: [],
            citizenStatus: 0,
            userCriticalPermissionsStatus: false,
            criticalPermissionsList: [
                { value: '1', label: 'Allow to display mobile number', key: 'mav20', status: false },
                { value: '2', label: 'Allow to display email id', key: 'mav21', status: false },
                { value: '3', label: 'Allow to call', key: 'mav22', status: false },
            ],
            userPermissions: [],
            allow_to_display_mobile_number: 0,
            allow_to_display_email_id: 0,

            teamLeadUsersList: [],
            teamLeadFK: null,
            teamLead: null,
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    watch: {
        teamLeadFK(newValue) {
            this.getTeamLeadValue(newValue);
        }
    },
    computed: {
        isAllSelected() {
            if (!this.nodes || this.nodes.length === 0) return false;
            let allKeys = [];
            const collectKeys = (nodes) => {
                if (!nodes) return;
                nodes.forEach(node => {
                    allKeys.push(node.key);
                    if (node.children) {
                        collectKeys(node.children);
                    }
                });
            };
            collectKeys(this.nodes);
            return allKeys.every(key => this.selectedTreeValue[key] && this.selectedTreeValue[key].checked);
        }
    },
    async mounted() {
        this.getStoragePath = JSON.parse(localStorage.getItem('storagePath'));
        this.clientBucketName = JSON.parse(localStorage.getItem('masterBucketName'));
        const localdata = JSON.parse(localStorage.user);
        this.allow_to_display_mobile_number = localdata.allow_to_display_mobile_number;
        this.allow_to_display_email_id = localdata.allow_to_display_email_id;
        this.loading = true;
        ({ data: this.titleList } = await this.ApiService.getTitles());
        this.superAdminUserList();
        this.getMenus();
        this.getSuperAdminRoles();
    },
    validations() {
        let validation = {
            title: { required: helpers.withMessage('Please select title', required) },
            userfirstname: { required: helpers.withMessage('Please enter first name', required), alpha: helpers.withMessage('Please input alphabet characters only', alpha) },
            userlastname: { required: helpers.withMessage('Please enter last name', required), alpha: helpers.withMessage('Please input alphabet characters only', alpha) },
            usermobile: { required: helpers.withMessage('Please enter mobile number', required), numeric: helpers.withMessage('Only numbers are allowed', numeric), minLength: minLength(10), maxLength: maxLength(10) },
            userEmail: { required: helpers.withMessage('Please enter email id', required), email: helpers.withMessage('Email id is invalid', email) },
            statustype: { required: helpers.withMessage('Please select status', required) },
            userPassword: { requiredIf: helpers.withMessage('Please enter password', requiredIf(this.userId)), minLength: minLength(8), maxLength: maxLength(20) },
            roletype: { required: helpers.withMessage('Please select role type', required) },
            teamLeadFK: {
                requiredIf: helpers.withMessage(
                    "Please select team lead",
                    requiredIf(
                        this.userId
                    )
                ),
            },
            userrole: {
                requiredIf: helpers.withMessage(
                    "Please select role",
                    requiredIf(
                        this.roletype == 1
                    )
                ),
            },
            selectedTreeValue: {
                requiredIf: helpers.withMessage(
                    "Please select module",
                    requiredIf(
                        this.roletype == 2
                    )
                ),
            },
        };
        return validation;
    },
    methods: {
        getTeamLeadValue(value) {
            const selectedUser = this.userslist.find(
            user => user.mav1 === value
            );
            this.teamLead = selectedUser ? selectedUser.mav8 : null;
        },
        async getUsersCriticalPermissions(userId) {
            try {
                this.userId = userId;
                const result = await this.ApiService.getUsersCriticalPermissions({ userId: userId });
                let userPermissions = result.data;
                this.criticalPermissionsList.forEach(permission => {
                    if (Object.prototype.hasOwnProperty.call(userPermissions, permission.key)) {
                        permission.status = userPermissions[permission.key] === 1;
                    }
                });
                if (!result.success) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            } catch (error) {
                return this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            }
        },

        serviceStatusChanges(data) {
            let fields = {};
            fields["userId"] = this.userId;
            if (data.status == 0 || data.status == false) {
                fields["status"] = 0;
            }
            if (data.status == 1 || data.status == true) {
                fields["status"] = 1;
            }
            fields["columnName"] = data.key;
            this.ApiService.addUsersCriticalPermissions(fields).then((items) => {
                if (items.success == true) {
                    var successMsg = items.message;
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                    this.getUsersCriticalPermissions(this.userId);
                    const user = JSON.parse(localStorage.getItem('user'));
                    user.allow_to_display_mobile_number = data.key === 'mav20' ? (data.status ? 1 : 0) : user.allow_to_display_mobile_number;
                    user.allow_to_display_email_id = data.key === 'mav21' ? (data.status ? 1 : 0) : user.allow_to_display_email_id;
                    localStorage.setItem('user', JSON.stringify(user));
                }
                else {
                    var errorMsg = items.message;
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                }
            });
        },

        async onSelectProfile(e) {
            this.profileImage = e.files[0];
            const file = e.files[0];
            let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!file.size > 2048) {
                this.profileImageError = 'File size cannot exceed more than 2MB';
                this.profileImage = '';
            } else if (!file.name.match(allowedExtensions)) {
                this.profileImageError = 'Invalid file type';
                this.profileImage = '';
            } else {
                this.profileImageError = '';
                if (file && file.type.includes('image/')) {
                    this.profileUrl = { url: file.objectURL, name: file.name };
                    this.profileImage = e.files[0];
                } else {
                    this.profileImageError = 'Invalid file type';
                    this.profileImage = '';
                }
            }
        },
        getMenus() {
            this.loading = true;
            this.ApiService.getMenus().then((data) => {
                if (data.status == 200) {
                    this.nodes = data.data;
                } else {
                    this.nodes = '';
                }
                this.loading = false;
            });
        },

        getSuperAdminRoles(e) {
            this.ApiService.getSuperAdminRoles(e).then((data) => {
                if (data.status == 200) {
                    this.userrole_list = data.data;
                }
            });
        },
        
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.unselectAll();
            } else {
                this.selectAll();
            }
        },
        selectAll() {
            let selectedKeys = {};
            const setSelected = (nodes) => {
                if (!nodes) return;
                nodes.forEach(node => {
                    selectedKeys[node.key] = { checked: true }; // Select node
                    if (node.children) {
                        setSelected(node.children);
                    }
                });
            };
            setSelected(this.nodes);
            this.selectedTreeValue = selectedKeys;
        },
        unselectAll() {
            this.selectedTreeValue = {}; // Clears all selections
        },
        toggleExpand() {
            if (this.isExpanded) {
                this.collapseAll();
            } else {
                this.expandAll();
            }
            this.isExpanded = !this.isExpanded; // Toggle the state
        },
        expandAll() {
            for (let node in this.nodes) {
                this.expandNode(this.nodes[node]);
            }
            this.expandedKeys = { ...this.expandedKeys };
        },

        collapseAll() {
            this.expandedKeys = {};
        },

        expandNode(node) {
            if (node.children && node.children.length) {
                this.expandedKeys[node.key] = true;
                for (let child of node.children) {
                    this.expandNode(child);
                }
            }
        },

        superAdminUserList(ev) {
            this.loading = true;
            this.ApiService.getSuperAdminUserList(ev).then(({ count, data, success }) => {
                if (success) {
                    this.userslist = data;
                    this.totalRecords = count;
                } else {
                    this.userslist = [];
                }
            }).catch(({ message }) => {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }).finally(() => {
                this.loading = false;
            });
        },

        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.superAdminUserList({ page_no: event.page, itemsPerPage: event.rows });
        },

        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault();
            }
        },

        addSuperAdminUsersDialogOpen() {
            this.submitted = false;
            this.addUserStatus = true;
            this.v$.$reset();
            this.userfirstname = "";
            this.usermiddlename = "";
            this.userlastname = "";
            this.usershortname = "";
            this.userfullname = "";
            this.usermobile = "";
            this.userEmail = "";
            this.statustype = 1;
            this.title = {};
            this.profileUrl = null;
            this.profileImage = null;
            this.userrole = [];
            this.roletype = '';
            this.selectedTreeValue = [];
            this.citizenStatus = 0;
            this.teamLeadUsersList = this.userslist;
            this.teamLeadFK = null;
            this.teamLead = null;
        },

        editSuperAdminUserDialogOpen(data) {
            this.expandedKeys = {};
            this.profileUrl = null;
            this.getSuperAdminRoles();
            this.submitted = false;
            this.editUserStatus = true;
            this.userprofilefile = null;
            ({
                mav1: this.userId,
                mav4: this.userfirstname,
                mav5: this.usermiddlename,
                mav6: this.userlastname,
                mav7: this.usershortname,
                mav8: this.userfullname,
                mav9: this.usermobile,
                mav10: this.userEmail,
                mav15: this.statustype,
                mav14: this.userPassword,
            } = data);
            this.userrole = [];
            let mav11data = this.userrole_list.filter(function (item) {
                return item.value == data.mav11;
            });
            if (mav11data.length > 0) {
                this.userrole = mav11data[0];
            }
            this.title = { label: data.mav3, value: data.mav2 };
            if (data.mav16 != null) {
                this.userprofilefile = data.mav16;
            }

            this.roletype = '';
            if (data.mav11 == 0 && data.mav12 != null) {
                this.roletype = 2;
            } else {
                this.roletype = 1;
            }
            this.selectedTreeValue = [];
            if (data.mav12 != null) {
                let arrConverted = data.mav12.split(",");
                this.selectedTreeValue = {};
                for (let index = 0; index < arrConverted.length; index++) {
                    let idxx = parseInt(arrConverted[index]); // Ensure the key is treated as an integer
                    this.selectedTreeValue[idxx] = { checked: true, partialChecked: false };
                }
            }
            this.citizenStatus = data.mav23 || 0;
            this.teamLeadUsersList = this.userslist.filter(
                user => user.mav1 !== data.mav1
            );

            this.$nextTick(() => {
                this.teamLeadFK = data.mav18 ? Number(data.mav18) : null;
            });
        },
        showCriticalPermissionsOfUser(data) {
            this.userCriticalPermissionsStatus = true;
            this.getUsersCriticalPermissions(data.mav1);
        },

        addNewSuperAdminUser() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();


            let formData = new FormData();
            formData.append('mav17', this.profileImage)
            formData.append('mav2', this.title.value);
            formData.append('mav3', this.title.label);
            formData.append('mav4', this.userfirstname);
            if (this.usermiddlename) {
                formData.append('mav5', this.usermiddlename);
            }
            formData.append('mav6', this.userlastname);
            formData.append('mav9', this.usermobile);
            formData.append('mav10', this.userEmail);
            formData.append('mav15', 1);
            if (this.userrole)
                formData.append('mav11', this.userrole.value);
            formData.append('mav23', this.citizenStatus || 0);
            formData.append('mav18', this.teamLeadFK || "");
            formData.append('mav19', this.teamLead || "");
            formData.append('role_type', this.roletype);
            formData.append('modules', JSON.stringify(this.selectedTreeValue));

            if (!this.v$.$error) {
                this.showLoader = true;
                this.ApiService.createUpdateSuperAdminUser(formData).then((items) => {
                    if (items.success) {
                        this.showLoader = false;
                        var successMsg = items.message;
                        this.addUserStatus = false;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        setTimeout(() => {
                            this.v$.$reset();
                        }, 0);
                        this.superAdminUserList();
                    } else {
                        this.showLoader = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },

        updateSuperAdminUser() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            if (this.profileImage) {
                formData.append('mav17', this.profileImage);
            }
            this.userId && formData.append('mav1', this.userId);
            this.title.value && formData.append('mav2', this.title.value);
            this.title.label && formData.append('mav3', this.title.label);
            this.userfirstname && formData.append('mav4', this.userfirstname);
            this.usermiddlename && formData.append('mav5', this.usermiddlename);
            this.userlastname && formData.append('mav6', this.userlastname);
            this.usershortname && formData.append('mav7', this.usershortname);
            this.userfullname && formData.append('mav8', this.userfullname);
            this.usermobile && formData.append('mav9', this.usermobile);
            this.userEmail && formData.append('mav10', this.userEmail);
            this.userPassword && formData.append('mav14', this.userPassword);
            this.statustype && formData.append('mav15', this.statustype);

            if (this.roletype == 1) {
                formData.append('mav11', this.userrole.value);
            } else if (this.roletype == 2) {
                formData.append('mav11', "");
            }
            formData.append('mav23', this.citizenStatus || 0);
            formData.append('mav18', this.teamLeadFK);
            formData.append('mav19', this.teamLead);
            formData.append('role_type', this.roletype);
            formData.append('modules', JSON.stringify(this.selectedTreeValue));
            if (!this.v$.$error) {
                this.showLoader = true
                this.ApiService.createUpdateSuperAdminUser(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoader = false;
                        var successMsg = items.message;
                        this.editUserStatus = false;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.userprofilefile = null;
                        setTimeout(() => {
                            this.v$.$reset();
                        }, 0);
                        this.superAdminUserList();
                        // Check if the edited userId matches the logged-in user's user_id from local storage
                        const currentUser = JSON.parse(localStorage.getItem('user'));
                        if (currentUser && currentUser.user_id === this.userId) {
                            this.showLoader = true
                            this.userLogout();
                        }
                    } else {
                        this.showLoader = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        userLogout() {
            this.ApiService.userlogout().then((items) => {
                if (items.status === 200) {
                    const successMsg = items.message;
                    this.showLoader = false
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                }
            });
        },
    },
};
</script>
<style scoped lang="scss">
.overflow-span {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    /* Optionally set a maximum width */
}

.user-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-active {
        background: #c8e6c9;
        color: #256029;
    }

    &.status-per-suspend {
        background: #ffcdd2;
        color: #c63737;
    }

    &.status-temp-suspend {
        background: #ffd8b2;
        color: #805b36;
    }
}
</style>
